import { Component } from '@angular/core';

@Component({
  selector: 'upsc-california-privacy',
  templateUrl: './california-privacy.component.html',
  styleUrls: ['./california-privacy.component.scss']
})
export class CaliforniaPrivacyComponent {

}
